import { assistantDisplayText } from './presentation';
import { ArrowRight, List, Trash2 } from '../../shared/ui/icons';
import { Button } from '../../shared/ui/button';
import type { SIAttachment } from './siAttachments';
import type { SICalendarWindow } from '../calendar/calendarAgentContext';

/** conversationId is the chat a message was written in; absent on takeoff prompts and on messages queued before it was recorded. */
/** webLookupId marks the message that continues a chat after the user approved a web search. */
export type QueuedSIMessage = { id: string; text: string; attachments?: SIAttachment[]; conversationId?: string; webLookupId?: string; calendar?: SICalendarWindow };
export type SIOutbox = { messages: QueuedSIMessage[]; paused: boolean };

export function SIMessageQueue({ messages, paused, onSteer, onRemove, onResume }: SIOutbox & {
 onSteer: (id: string) => void;
 onRemove: (id: string) => void;
 onResume: () => void;
}) {
 if (!messages.length) return null;
 return <section aria-label="Queued messages" className="mx-4 shrink-0 rounded-t-2xl border border-b-0 border-border px-2 pt-1 text-sm">
  {paused && <div className="flex items-center justify-between px-2 py-1 text-xs text-muted-foreground">
   <span>Queue paused</span><Button variant="ghost" size="sm" aria-label="Resume queued messages" onClick={onResume}>Resume</Button>
  </div>}
  <ul className="max-h-36 overflow-y-auto">
   {messages.map(message => <li key={message.id} className="flex min-w-0 items-center gap-2 py-1">
    <List aria-hidden className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
    <span className="min-w-0 flex-1 truncate" title={assistantDisplayText(message.text)}>{assistantDisplayText(message.text)}</span>
    {message.attachments?.length ? <span className="shrink-0 text-xs text-muted-foreground">{message.attachments.length === 1 ? '1 file' : `${message.attachments.length} files`}</span> : null}
    <Button variant="ghost" size="sm" className="h-7 shrink-0 gap-1 px-2 text-xs text-muted-foreground" aria-label="Steer queued message" onClick={() => onSteer(message.id)}>
     <ArrowRight aria-hidden className="h-3 w-3" />Steer
    </Button>
    <Button variant="ghost" size="icon" className="h-7 w-7 shrink-0 text-muted-foreground" aria-label="Remove queued message" onClick={() => onRemove(message.id)}>
     <Trash2 aria-hidden className="h-3.5 w-3.5" />
    </Button>
   </li>)}
  </ul>
 </section>;
}
